import {FC} from 'react'

interface DragInDropLoadingProps {
  rows?: number
  columns: number
  selectable?: boolean
  hasActions?: boolean
}

export const DragInDropLoading: FC<DragInDropLoadingProps> = ({
  rows = 5,
  columns,
  selectable = false,
  hasActions = false,
}) => {
  const totalColumns = columns + (selectable ? 1 : 0) + (hasActions ? 1 : 0)

  return (
    <tbody>
      {Array.from({length: rows}, (_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({length: totalColumns}, (_, colIndex) => (
            <td key={colIndex} className='py-3'>
              <div className='d-flex align-items-center'>
                <div
                  className='bg-light rounded'
                  style={{
                    height: '20px',
                    width: `${Math.random() * 60 + 40}%`,
                    animation: 'pulse 1.5s ease-in-out infinite',
                  }}
                ></div>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  )
}

interface DragInDropErrorProps {
  message: string
  onRetry?: () => void
  columns: number
  selectable?: boolean
  hasActions?: boolean
}

export const DragInDropError: FC<DragInDropErrorProps> = ({
  message,
  onRetry,
  columns,
  selectable = false,
  hasActions = false,
}) => {
  const totalColumns = columns + (selectable ? 1 : 0) + (hasActions ? 1 : 0)

  return (
    <tbody>
      <tr>
        <td colSpan={totalColumns} className='text-center py-10'>
          <div className='d-flex flex-column align-items-center'>
            <i className='fas fa-exclamation-triangle fs-2x text-warning mb-3'></i>
            <h5 className='text-muted mb-2'>Erro ao carregar dados</h5>
            <p className='text-muted mb-4'>{message}</p>
            {onRetry && (
              <button className='btn btn-primary btn-sm' onClick={onRetry}>
                <i className='fas fa-redo me-1'></i>
                Tentar novamente
              </button>
            )}
          </div>
        </td>
      </tr>
    </tbody>
  )
}
